export const isProd = process.env.NODE_ENV === 'production';
export const CASHIER_REDIRECT_WINDOW = 'CASHIER_REDIRECT_WINDOW';

export const REDIRECTION_TYPE = {
  SELF: 'self',
  NEW_WINDOW: 'new_window',
  EMBEDDED: 'embedded',
};
